import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { EditObservationsActionContext } from "./EditObservationsActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(
    EditObservationsActionContext
  );
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    const dataToSend = {
      ...element,
      type: "observation",
    };

    update("super-orders", element.id, dataToSend)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
